import request from '@/utils/request'

export function getConsentInfo(param) {
  let data = param
  return request({
    url: `/a7000/getConsentInfo`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function getAgreement(param) {
  let data = param
  return request({
    url: `/a7000/getAgreement`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function getEmpInfo(param) {
  let data = param
  return request({
      url: `/a7000/getEmpInfo`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
  })
}

export function submitAgreement(param) {
  let data = param
  return request({
      url: `/a7000/submitAgreement`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
  })
}

export function getEmpSign(param) {
  let data = param
  return request({
      url: `/a7000/getEmpSign`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
  })
}

export function downloadAgreement(param) {
  return request({
      url: `/a7000/downloadAgreement`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      responseType: 'blob',   // 🔥 QUAN TRỌNG
      data: param
  })
}


